<template>
  <v-card class="pa-6 rounded-lg" :elevation="isMobileOrIPad ? 0 : 4">
    <div class="mb-6">
      <ReservationCard :show-info="false" :reservation="reservation" />
    </div>

    <v-row class="mt-2 mb-6">
      <v-col cols="6" class="pr-4 border-right">
        <CheckDateBox
          :title="$t('Checkin')"
          :date="reservation.check_in"
          :timezone="listing.timezone"
          :time="reservation.planned_arrival"
        />
      </v-col>
      <v-col cols="6" class="pr-4 border-right">
        <CheckDateBox
          :title="$t('Checkout')"
          :date="reservation.check_out"
          :timezone="listing.timezone"
          :time="reservation.planned_departure"
        />
      </v-col>
    </v-row>

    <v-divider class="mb-6"></v-divider>

    <div v-if="!isDeposit">
      <div class="price-breakdown">
        <div
          v-for="(product, idx) in filteredItems"
          :key="idx"
          class="d-flex align-center justify-space-between mb-3"
        >
          <span class="text-body-1 grey--text text--darken-3">{{
            product.title
          }}</span>
          <span class="text-body-1 font-weight-medium">{{
            toCurrency(product.amount, { currency: reservation.currency })
          }}</span>
        </div>
      </div>

      <v-divider class="my-4"></v-divider>

      <div class="d-flex justify-space-between align-center mb-2">
        <span class="text-subtitle-1 font-weight-bold">{{ $t('Total') }}</span>
        <span class="text-subtitle-1 font-weight-bold">{{
          toCurrency(itemsTotal, { currency: reservation.currency })
        }}</span>
      </div>

      <div
        class="d-flex justify-space-between align-center mt-6 pt-4"
        style="border-top: 2px solid #f5f5f5"
      >
        <span class="text-h6 primary--text font-weight-bold">
          {{ $t('Amount to charge') }}
        </span>
        <span class="text-h5 primary--text font-weight-bold">{{
          toCurrency(payment.amount / 100, { currency: paymentCurrency })
        }}</span>
      </div>
    </div>

    <div v-else>
      <div class="d-flex justify-space-between mb-4">
        <span class="text-body-1 font-weight-medium">
          {{ $t('Deposit') }}
        </span>
        <span class="text-body-1 font-weight-bold">{{
          toCurrency(payment.amount / 100, { currency: paymentCurrency })
        }}</span>
      </div>
      <v-divider class="my-4" />
      <div class="d-flex justify-space-between align-center">
        <span class="text-h6 font-weight-bold">{{ $t('Total') }}</span>
        <span class="text-h6 font-weight-bold primary--text">{{
          toCurrency(payment.amount / 100, { currency: paymentCurrency })
        }}</span>
      </div>
    </div>
  </v-card>
</template>

<script>
import ReservationCard from '@/components/common/reservation-card'
import deviceMixin from '@/components/mixins/deviceMixin'
import commonFunctions from 'components/mixins/common-functions'
import CheckDateBox from 'components/common/check-date-box.vue'

export default {
  name: 'ReservationCheckoutSummary',

  components: { CheckDateBox, ReservationCard },
  mixins: [deviceMixin, commonFunctions],
  props: ['reservation', 'payment'],
  computed: {
    listing() {
      return this.reservation.listing
    },
    filteredItems() {
      const invoiceItems = this.reservation.invoice_items || []
      const additionalItems = this.reservation.additional_invoice_items || []

      // Inclusive VAT is already part of the accommodation fare, so
      // including its separate row would double-count it in the Total.
      return [...invoiceItems, ...additionalItems].filter(
        item => item.amount > 0 && !item.vat_inclusive
      )
    },
    itemsTotal() {
      return this.filteredItems.reduce(
        (sum, item) => sum + Number(item.amount),
        0
      )
    },
    isDeposit() {
      return this.payment.capture_method === 'manual'
    },
    paymentCurrency() {
      return this.payment.currency || this.listing.get_currency
    },
  },
}
</script>

<style scoped></style>
